import { render, staticRenderFns } from "./interlocution.vue?vue&type=template&id=0bc834f3&scoped=true"
import script from "./interlocution.vue?vue&type=script&lang=js"
export * from "./interlocution.vue?vue&type=script&lang=js"
import style0 from "./interlocution.vue?vue&type=style&index=0&id=0bc834f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc834f3",
  null
  
)

export default component.exports